import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { socket } from "../../App";
import axios from "../../components/Hooks/axios";

const initialState = {
	userId: "",
	user: null,
	token: "",
};

const authSlice = createSlice({
	name: "authSlice",
	initialState,
	reducers: {
		fetchDataFromLocalStorage: (state) => {
			const safeParseCookie = (cookieName) => {
				try {
					const val = Cookies.get(cookieName);
					if (!val || val === "undefined" || val === "null") return null;
					return JSON.parse(val);
				} catch (e) {
					const val = Cookies.get(cookieName);
					return val && val !== "undefined" && val !== "null" ? val : null;
				}
			};

			const userId = safeParseCookie("E_current_userId");
			const token = safeParseCookie("E_token");
			const user = safeParseCookie("E_current_user_obj");

			if (userId) state.userId = userId;
			if (token) state.token = token;
			if (user) state.user = user;
		},

		setAuth: (state, { payload }) => {
			if (!payload) return;
			if (payload.userId) state.userId = payload.userId;
			if (payload.token) state.token = payload.token;

			const expires = payload.rememberMe ? { expires: 50 } : undefined;

			if (payload.userId) {
				Cookies.set("E_current_userId", JSON.stringify(payload.userId), expires);
			}
			if (payload.token) {
				Cookies.set("E_token", JSON.stringify(payload.token), expires);
			}
			if (payload.rememberMe) {
				Cookies.set("rememberMe", "rememberMe");
			}
		},

		setUserObject: (state, { payload }) => {
			if (!payload) return;
			state.user = payload;

			if (Cookies.get("rememberMe") === undefined) {
				Cookies.set("E_current_user_obj", JSON.stringify(payload));
			} else {
				Cookies.set("E_current_user_obj", JSON.stringify(payload), { expires: 50 });
			}
		},

		logOut: (state) => {
			axios.defaults.headers.Authorization = "";
			if (state.userId) {
				socket.emit("leaveLogoutRoom", state.userId);
			}
			state.userId = "";
			state.token = "";
			state.user = null;
			Cookies.remove("E_current_user_obj");
			Cookies.remove("E_current_userId");
			Cookies.remove("E_persona_userId");
			Cookies.remove("E_token");
			Cookies.remove("rememberMe");
		},

		switchAccount: (state, { payload }) => {
			if (!payload) return;
			if (payload.userId) state.userId = payload.userId;
			if (payload.user) state.user = payload.user;
			if (payload.token) state.token = payload.token;

			if (payload.token) {
				axios.defaults.headers.Authorization = payload.token;
			}

			const expires = Cookies.get("rememberMe") !== undefined ? { expires: 50 } : undefined;

			if (payload.userId) Cookies.set("E_current_userId", JSON.stringify(payload.userId), expires);
			if (payload.user) Cookies.set("E_current_user_obj", JSON.stringify(payload.user), expires);
			if (payload.token) Cookies.set("E_token", JSON.stringify(payload.token), expires);
		},
	},
});

export const { fetchDataFromLocalStorage, setAuth, setUserObject, logOut, switchAccount } = authSlice.actions;
export default authSlice.reducer;


